<template>
  <project-form-view
    :loading="loading"
    :error="error"
    :created="created"
    :name="name"
    @set_name="set_name"
    @save="local_save"
    @create="local_create"
    @remove="remove"
  >
    <project-assessment
      v-for="assessment_id in assessment_ids"
      :id="assessment_id"
      :key="assessment_id"
      @remove="remove_assessment(assessment_id)"
    />
    <new-assessment @add_assessment="add_assessment" />
  </project-form-view>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { TALENTQ_STORE_NAMES } from '@/stores_new/vacancy_talentq/constants';
  import ProjectFormView from '../../components/project/project-form-view';
  import ProjectAssessment from './project-assessment';
  import NewAssessment from '../../components/project/new-assessment';
  import cloneDeep from 'lodash/cloneDeep';
  import difference from 'lodash/difference';
  import assessment_store from '@/stores_new/vacancy_talentq/project_form/assessment';
  import { PROJECT_ASSESSMENT_STORE_PREFIX } from '@/stores_new/vacancy_talentq/project_form/constants';

  const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers(
    'vacancy_talentq/' + TALENTQ_STORE_NAMES.PROJECT_FORM
  );

  export default {
    name: 'ProjectForm',

    components: { NewAssessment, ProjectAssessment, ProjectFormView },

    computed: {
      ...mapGetters(['loading', 'error', 'created', 'name', 'assessment_ids'])
    },

    created() {
      this.set_form_data();
    },

    methods: {
      ...mapMutations([
        'set_name',
        'set_created',
        'set_assessment_ids',
        'add_assessment_id',
        'remove_assessment_id'
      ]),

      ...mapActions(['create', 'save', 'remove']),

      local_save() {
        this.save()
          .then(this.set_form_data) // Так как id формы не изменился, но появится id у полей формы, обновляем стору
          .catch(error => {
            this.$noty.error(error.message);
          });
      },

      local_create() {
        this.create().catch(error => {
          this.$noty.error(error.message);
        });
      },

      unregister_field_module(assessment_id) {
        this.$store.unregisterModule(PROJECT_ASSESSMENT_STORE_PREFIX + assessment_id);
      },

      // вызывается во время первого рендера компонентов, и после каждого сохранения
      set_form_data() {
        const data = this.$store.getters[`vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT}/data`];
        // В случае когда создаётся новая анкета, чистим стору
        if (!data) {
          this.set_name('');
          this.set_created(false);
          this.assessment_ids.forEach(this.unregister_field_module);
          this.set_assessment_ids([]);
          return;
        }
        this.set_name(data.name);
        this.set_created(true);
        const new_assessment_ids = data.assessments.map(assessment => {
          const store_key = PROJECT_ASSESSMENT_STORE_PREFIX + assessment.id;
          if (!this.$store.state[store_key]) {
            this.$store.registerModule(store_key, assessment_store);
          }
          this.$store.commit(store_key + '/set_state', cloneDeep(assessment));
          return assessment.id;
        });
        const need_unregister = difference(this.assessment_ids, new_assessment_ids);
        this.set_assessment_ids(new_assessment_ids);
        need_unregister.forEach(this.unregister_field_module);
      },

      add_assessment() {
        const assessment_id = Date.now();
        this.$store.registerModule(
          PROJECT_ASSESSMENT_STORE_PREFIX + assessment_id,
          assessment_store
        );
        this.$store.commit(PROJECT_ASSESSMENT_STORE_PREFIX + assessment_id + '/set_state', {
          saved: false
        });
        this.add_assessment_id(assessment_id);
      },

      remove_assessment(assessment_id) {
        this.remove_assessment_id(assessment_id);
        this.$store.unregisterModule(PROJECT_ASSESSMENT_STORE_PREFIX + assessment_id);
      }
    }
  };
</script>
